var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRibbonPawprintSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "381px",
    height: "1954px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 381 1953",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n   \n    .str0 {stroke:black;stroke-width:8.85525}\n    .fil1 {fill:#CC9933}\n    .fil0 {fill:#CCCCCC}\n   \n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil0 str0",
    points: "9,9 372,9 372,1944 192,1767 9,1944 "
  }), /*#__PURE__*/React.createElement("g", {
    id: "_492620608"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M234 1555c3,-8 13,-12 26,-6 12,5 19,18 14,26 -6,8 -16,11 -27,6 -11,-6 -17,-17 -13,-26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M229 1688c3,8 13,13 26,8 13,-5 20,-17 15,-25 -4,-9 -14,-12 -26,-7 -11,4 -18,16 -15,24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M214 1664c11,0 22,-3 26,-11 4,-8 -1,-18 -7,-22 -6,-3 -13,-4 -20,-3 -26,3 -28,37 1,36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M216 1578c12,1 23,6 27,15 4,8 -2,17 -9,20 -5,3 -13,4 -20,2 -27,-4 -27,-39 2,-37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M280 1664c0,-1 -1,-2 -1,-2 -5,-7 -11,-12 -19,-17 -4,-2 -7,-5 -9,-9 -6,-9 -5,-16 -1,-23 6,-9 15,-14 24,-20 8,-5 13,-12 21,-17 6,-3 14,-5 23,-2 14,5 17,17 13,30 -1,4 -2,8 -3,11 -3,8 -3,16 0,25 1,4 2,8 2,12 2,17 -8,28 -26,26 -9,-1 -18,-7 -24,-14z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M234 900c3,-8 13,-12 26,-7 12,6 19,18 14,26 -6,9 -16,12 -27,6 -11,-5 -17,-17 -13,-25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M229 1033c3,8 13,12 26,8 13,-5 20,-17 15,-26 -4,-8 -14,-12 -26,-7 -11,5 -18,16 -15,25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M214 1009c11,0 22,-4 26,-12 4,-8 -1,-17 -7,-21 -6,-4 -13,-4 -20,-3 -26,3 -28,36 1,36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M216 922c12,1 23,7 27,15 4,8 -2,17 -9,21 -5,3 -13,3 -20,2 -27,-5 -27,-40 2,-38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M280 1008c0,-1 -1,-1 -1,-2 -5,-6 -11,-11 -19,-16 -4,-3 -7,-5 -9,-9 -6,-9 -5,-17 -1,-24 6,-9 15,-14 24,-19 8,-5 13,-12 21,-17 6,-4 14,-5 23,-3 14,6 17,18 13,31 -1,3 -2,7 -3,11 -3,8 -3,16 0,25 1,4 2,8 2,12 2,16 -8,28 -26,26 -9,-1 -18,-8 -24,-15z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M234 244c3,-8 13,-12 26,-6 12,5 19,18 14,26 -6,8 -16,11 -27,6 -11,-6 -17,-17 -13,-26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M229 377c3,8 13,13 26,8 13,-5 20,-17 15,-25 -4,-9 -14,-12 -26,-7 -11,4 -18,16 -15,24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M214 353c11,0 22,-3 26,-11 4,-8 -1,-18 -7,-22 -6,-3 -13,-4 -20,-3 -26,3 -28,37 1,36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M216 267c12,1 23,6 27,15 4,8 -2,17 -9,20 -5,3 -13,4 -20,2 -27,-4 -27,-39 2,-37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M280 353c0,-1 -1,-2 -1,-2 -5,-7 -11,-12 -19,-17 -4,-2 -7,-5 -9,-9 -6,-9 -5,-16 -1,-23 6,-9 15,-14 24,-20 8,-5 13,-12 21,-17 6,-3 14,-5 23,-2 14,5 17,17 13,30 -1,4 -2,7 -3,11 -3,8 -3,16 0,25 1,4 2,8 2,12 2,17 -8,28 -26,26 -9,-1 -18,-8 -24,-14z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M197 1472c7,6 7,17 -2,27 -10,10 -24,12 -30,4 -6,-8 -5,-19 4,-27 9,-9 22,-10 28,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M74 1422c-9,0 -16,8 -16,21 0,14 9,25 18,24 10,-2 17,-10 16,-22 0,-13 -9,-23 -18,-23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M102 1416c-4,10 -4,22 2,28 6,6 17,5 22,1 5,-4 9,-10 10,-18 6,-25 -25,-38 -34,-11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M182 1448c-5,11 -14,19 -23,20 -9,0 -15,-8 -16,-16 -1,-6 1,-13 5,-20 14,-23 46,-11 34,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M80 1478c0,0 1,0 2,0 7,-3 14,-7 22,-12 4,-3 7,-5 11,-6 11,-2 18,1 23,7 6,9 8,19 10,30 2,8 7,16 8,25 2,7 1,15 -5,23 -10,11 -22,10 -33,2 -3,-3 -6,-5 -9,-7 -7,-6 -15,-9 -24,-9 -4,0 -8,-1 -12,-2 -16,-4 -24,-17 -15,-33 4,-8 13,-15 22,-18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M197 816c7,7 7,17 -2,27 -10,10 -24,12 -30,4 -6,-8 -5,-18 4,-27 9,-8 22,-10 28,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M74 766c-9,0 -16,8 -16,22 0,14 9,25 18,23 10,-2 17,-10 16,-22 0,-12 -9,-23 -18,-23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M102 760c-4,11 -4,22 2,29 6,6 17,5 22,0 5,-4 9,-10 10,-17 6,-26 -25,-39 -34,-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M182 792c-5,11 -14,20 -23,20 -9,1 -15,-8 -16,-15 -1,-6 1,-13 5,-20 14,-24 46,-12 34,15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M80 823c0,0 1,-1 2,-1 7,-2 14,-7 22,-12 4,-2 7,-4 11,-5 11,-3 18,1 23,7 6,8 8,19 10,29 2,9 7,17 8,26 2,7 1,14 -5,23 -10,10 -22,9 -33,1 -3,-2 -6,-4 -9,-7 -7,-5 -15,-8 -24,-9 -4,0 -8,0 -12,-1 -16,-4 -24,-17 -15,-34 4,-8 13,-14 22,-17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M197 161c7,6 7,17 -2,27 -10,10 -24,12 -30,4 -6,-8 -5,-19 4,-27 9,-9 22,-10 28,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M74 111c-9,0 -16,8 -16,21 0,14 9,25 18,24 10,-2 17,-10 16,-22 0,-13 -9,-23 -18,-23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M102 105c-4,10 -4,21 2,28 6,6 17,5 22,1 5,-4 9,-10 10,-18 6,-25 -25,-38 -34,-11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M182 137c-5,11 -14,19 -23,20 -9,0 -15,-8 -16,-16 -1,-6 1,-13 5,-20 14,-23 46,-11 34,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M80 167c0,0 1,0 2,0 7,-3 14,-7 22,-12 4,-3 7,-5 11,-6 11,-2 18,1 23,7 6,9 8,19 10,29 2,9 7,17 8,26 2,7 1,15 -5,23 -10,11 -22,9 -33,2 -3,-3 -6,-5 -9,-7 -7,-6 -15,-9 -24,-9 -4,-1 -8,-1 -12,-2 -16,-4 -24,-17 -15,-33 4,-8 13,-15 22,-18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M181 1316c-7,6 -7,17 3,27 9,10 23,12 29,4 6,-8 5,-18 -4,-27 -9,-9 -22,-10 -28,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M304 1266c9,0 16,8 16,22 0,13 -8,24 -18,23 -10,-2 -16,-10 -16,-22 1,-13 9,-23 18,-23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M276 1260c4,11 5,22 -2,28 -6,7 -16,5 -22,1 -5,-4 -8,-10 -10,-18 -6,-25 25,-38 34,-11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M196 1292c5,11 14,20 23,20 9,1 16,-8 17,-15 1,-7 -2,-14 -6,-21 -13,-23 -46,-11 -34,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M299 1322c-1,0 -2,0 -3,0 -7,-2 -14,-7 -21,-12 -4,-3 -8,-5 -12,-6 -10,-2 -17,1 -22,8 -7,8 -8,19 -11,29 -1,9 -6,16 -8,25 -1,7 0,15 5,23 11,11 23,10 33,2 3,-3 7,-5 10,-7 6,-6 14,-8 23,-9 4,0 8,-1 12,-2 17,-3 24,-17 16,-33 -4,-8 -14,-15 -22,-18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M181 660c-7,7 -7,17 3,27 9,10 23,12 29,4 6,-8 5,-18 -4,-27 -9,-8 -22,-10 -28,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M304 611c9,0 16,7 16,21 0,14 -8,25 -18,23 -10,-1 -16,-9 -16,-22 1,-12 9,-22 18,-22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M276 604c4,11 5,22 -2,29 -6,6 -16,5 -22,0 -5,-3 -8,-10 -10,-17 -6,-25 25,-38 34,-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M196 637c5,11 14,19 23,20 9,0 16,-9 17,-16 1,-6 -2,-13 -6,-20 -13,-24 -46,-11 -34,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M299 667c-1,0 -2,-1 -3,-1 -7,-2 -14,-6 -21,-11 -4,-3 -8,-5 -12,-6 -10,-3 -17,1 -22,7 -7,8 -8,19 -11,29 -1,9 -6,17 -8,26 -1,7 0,14 5,23 11,11 23,9 33,1 3,-2 7,-4 10,-7 6,-5 14,-8 23,-8 4,-1 8,-1 12,-2 17,-4 24,-17 16,-34 -4,-8 -14,-14 -22,-17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M85 1097c3,-8 13,-12 26,-7 13,6 19,18 14,27 -6,8 -16,11 -27,5 -11,-5 -17,-17 -13,-25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M80 1230c3,8 13,13 26,8 13,-5 21,-17 16,-25 -5,-9 -15,-12 -27,-8 -11,5 -18,16 -15,25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M65 1206c11,0 22,-4 26,-12 4,-8 -1,-17 -7,-21 -5,-3 -12,-4 -20,-3 -26,3 -27,36 1,36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M67 1120c13,0 24,6 27,14 4,8 -2,18 -9,21 -5,3 -12,4 -20,2 -27,-5 -27,-39 2,-37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M131 1205c0,0 0,-1 -1,-2 -5,-6 -11,-11 -18,-16 -4,-3 -7,-5 -10,-9 -6,-9 -5,-17 -1,-23 6,-9 15,-14 24,-20 8,-5 13,-12 21,-17 6,-3 14,-5 24,-3 13,6 16,18 12,31 -1,4 -2,7 -3,11 -3,8 -3,16 0,25 1,4 2,8 2,12 3,17 -7,28 -25,26 -9,-1 -19,-8 -25,-15z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M85 442c3,-9 13,-13 26,-7 13,5 19,18 14,26 -6,8 -16,11 -27,6 -11,-6 -17,-17 -13,-25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M80 574c3,9 13,13 26,8 13,-4 21,-16 16,-25 -5,-8 -15,-12 -27,-7 -11,5 -18,16 -15,24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M65 551c11,0 22,-4 26,-12 4,-8 -1,-18 -7,-22 -5,-3 -12,-4 -20,-3 -26,3 -27,37 1,37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M67 464c13,1 24,6 27,15 4,8 -2,17 -9,21 -5,3 -12,3 -20,2 -27,-5 -27,-40 2,-38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M131 550c0,-1 0,-1 -1,-2 -5,-6 -11,-11 -18,-16 -4,-3 -7,-6 -10,-9 -6,-9 -5,-17 -1,-24 6,-9 15,-14 24,-19 8,-5 13,-13 21,-17 6,-4 14,-6 24,-3 13,6 16,18 12,30 -1,4 -2,8 -3,11 -3,8 -3,17 0,25 1,4 2,8 2,12 3,17 -7,29 -25,27 -9,-2 -19,-8 -25,-15z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbonPawprintSilver);
export default __webpack_public_path__ + "static/media/ribbon-pawprint-silver.ae396bd005400c883b3650a7aee25974.svg";
export { ForwardRef as ReactComponent };